<!-- 自定义页面 -->
<template>
  <div class='custom_page'>
    <div
      class="custom_body"
      :class="this.$root.isVersion ? 'custom_body_vers' : ''"
    >
      <!-- 图文模式内容 -->
      <div
        v-if="options.type === 0"
        class="custom_rich_text"
        :class="this.$root.isVersion ? 'text_version' : ''"
        v-html="options.content"
      ></div>
      <!-- 纯图模式内容 -->
      <div
        v-else-if="options.type === 1"
        class="custom_images"
        :class="this.$root.isVersion ? 'img_version' : ''"
      >
        <div
          v-for="item of options.content"
          :key="item.id"
        >
          <a
            :href="item.jumpUrl"
            v-if="item.jumpUrl"
          >
            <img
              lazy-load
              class="custom_image_item"
              :src="item.url"
            >
          </a>
          <img
            v-else
            lazy-load
            class="custom_image_item"
            :src="item.url"
            @click="handleClickImage(item)"
          >
        </div>

      </div>
    </div>

    <!-- 版权 -->
    <PCopyright
      class="copyright_item"
      v-show="this.$root.isVersion"
    />

    <!-- 图片预览 -->
    <van-image-preview
      :showIndex="false"
      v-model="isPreview"
      :images="previewList"
    ></van-image-preview>

    <div
      v-show="loading"
      class="loading_wrap"
    >
      <van-loading
        class="loading"
        color="#1989fa"
      />
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Loading, Lazyload } from 'vant'
import PCopyright from '@c/PCopyright'
Vue.use(Loading)
Vue.use(Lazyload)

import { GetCustomOptions } from '@a/js/api/custom'
import { SimpleQicukSort, ObjectDeepClone } from '@a/js/utils'
import { GetWxshareConfig, GetVersionOption } from '@a/js/api/public'
import { SetWechatShare } from '@a/js/utils'
import { Base64 } from 'js-base64'
import wx from 'weixin-js-sdk'
import apiObj from '@a/js/api.js'
export default {
  name: 'Custom',
  data() {
    return {
      params: {},
      options: {
        uid: '',
        type: 0,
        content: ''
      },
      loading: true,
      // 预览图
      isPreview: false,
      previewList: [],
    };
  },

  components: {
    PCopyright
  },

  methods: {
    // 获取页面配置信息
    getPageOptions() {
      let data = {
        account_uid: this.params.accountid,
        project_uid: this.params.projectid,
        data_uid: this.params.pageid
      }
      GetCustomOptions(data).then(res => {
        let response = ObjectDeepClone(res.data)
        if (response.type === 1) {
          response.content = SimpleQicukSort(ObjectDeepClone(response.content))
        }
        this.options = response
        this.loading = false
      }).catch(() => { })
    },
    // 获取数据请求参数
    getParams() {
      return new Promise(resolve => {
        this.params = this.$route.params
        resolve()
      })
    },
    // 点击图片跳转链接
    handleClickImage(item) {
      if (item.jumpUrl.length > 0) {
        window.location.href = item.jumpUrl
      } else {
        this.previewList = []
        this.previewList.push(item.url)
        this.isPreview = true
      }
    },
    // 页面初始化获取微信分享配置
    InitGetWxShareConfig() {
      let href = window.location.href.split('#')[0]
      let resdata = {
        account_uid: this.params.accountid,
        project_uid: this.params.projectid,
        app_name: this.$AppName,
        url: Base64.encode(href),
      }
      GetWxshareConfig(resdata)
        .then((res) => {
          // console.log(res)
          if (res.data.config.appId) {
            let imgUrl = ''
            if (res.data.info.img.length > 0) {
              imgUrl = apiObj.VUE_APP_BASE_CDN + res.data.info.img
            }
            SetWechatShare(wx, res.data, href, imgUrl)
          }
        })
        .catch(() => { })
    },
    // 初始化版权信息
    initVersionOption() {
      let data = {
        account_uid: this.params.accountid,
        app_name: 'version',
        type: 4,
      }
      GetVersionOption(data)
        .then((res) => {
          this.$root.isVersion = res.data.is_version
        })
        .catch(() => { })
    },
  },

  mounted() {
    this.getParams().then(() => {
      this.getPageOptions()
      this.InitGetWxShareConfig()
      this.initVersionOption()
    })

  },
}
</script>
<style lang='less' scoped>
.custom_page {
  position: relative;
  // min-width: 100vw;
  min-height: 100vh;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  .custom_body {
    flex: 1;
  }
  /deep/.custom_rich_text {
    padding: 0 15px;
    width: 100%;
    box-sizing: border-box;
    p {
      line-height: 1.2;
    }
    img {
      width: 100%;
      // margin: 5px 0;
    }
    strong {
      font-weight: bold;
    }
    em {
      font-style: italic;
    }
    /deep/ .ql-align-center {
      text-align: center;
    }
  }
  // .text_version {
  //   padding-bottom: 55px;
  // }
  .custom_images {
    font-size: 0;

    .custom_image_item {
      width: 100%;
    }
  }
  // .img_version {
  //   padding-bottom: 40px;
  // }
  .loading_wrap {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 100;
    background: rgba(255, 255, 255, 1);
    .loading {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}
</style>

<style lang="less" >
// @media screen and (min-width: 1100px) {
//   .custom_page {
//     min-height: auto !important;
//     min-width: 375px !important;
//     height: 667px !important;
//     overflow: auto;
//     scrollbar-width: none; /* firefox */
//     -ms-overflow-style: none; /* IE 10+ */
//     &::-webkit-scrollbar {
//       width: 0px;
//       height: 0px;
//     }
//   }
//   .Copyright_wrap {
//     position: relative !important;
//   }
// }
</style>